import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
	"inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
	{
		variants: {
			variant: {
				default: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
				destructive: "bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90",
				outline: "border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
				secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
				ghost: "hover:bg-accent hover:text-accent-foreground",
				link: "text-primary underline-offset-4 hover:underline",
				// The club look: a solid slab with a 3px lip, used for the primary
				// call to action on a page. Pair with size="club".
				club: "bg-primary text-primary-foreground shadow-club transition-[filter] hover:brightness-110",
				"club-secondary": "bg-muted border border-border transition-[filter] hover:brightness-110"
			},
			size: {
				default: "h-9 px-4 py-2",
				xs: "h-7 rounded px-2",
				sm: "h-8 rounded-md px-3 text-xs",
				lg: "h-10 rounded-md px-8",
				icon: "h-9 w-9",
				"icon-sm": "size-8",
				"icon-lg": "size-10",
				club: "min-h-12 gap-3 rounded-md px-5 py-3 text-[15px] font-bold [&_svg]:size-5"
			}
		},
		defaultVariants: {
			variant: "default",
			size: "default"
		}
	}
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
